import 'component/css/payment.css';

import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileImage,
  faPlus,
  faWindowMaximize,
  faWindowMinimize,
} from '@fortawesome/free-solid-svg-icons';

import Util, { Data } from 'service/util';

import ModalScreen from 'component/ModalScreen';
import Protected from 'component/Protected';

import PaymentAcceptModal from 'component/service-edit/PaymentAcceptModal';
import PaymentCard from 'component/payment/PaymentCard';

const getPaymonthRowText = p => `${p.l}: ` + ( p.n != p.x ? `${p.n} 至 ${p.x}` : String(p.n) );
const getPaymonthTitle = iv => iv.pay_month?.map(getPaymonthRowText).join('\r\n');

const PaymentList = ({owner, bills, ...props}) =>
{
  if (!props.onUpdated) throw new Error('must provide payment update callback');

  const [modal, setModal]              = useState(false);
  const [filter_com, setFilterCompany] = useState('');
  const [filter_ref, setFilterRef]     = useState('');

  const [items, setItems] = useState(props.payments);

  const [maximize_list, setMaximize] = useState(false);
  const toggleMaximize = e=>setMaximize(!maximize_list);


  const closeModal = () =>
  {
    setModal(null);
  }

  const showAddModal = () =>
  {
    let modal =
      <ModalScreen title="確認收款" show={true} onClose={closeModal}>
        <PaymentAcceptModal bills={bills} owner={owner}
          onClose={ closeModal } onUpdated={ props.onUpdated }
        />
      </ModalScreen>;
    setModal(modal);
  }

  const showPaymentDetail = (pay) =>
  {
    let modal =
      <ModalScreen className="payment-receipt-modal" title="收款記錄" show={true} onClose={ closeModal }>
        <PaymentCard payment={pay} onClose={ closeModal }/>
      </ModalScreen>
    setModal( modal );
  }

  //------------------------------------------------
  // init
  useEffect(() => {
    // skip if nothing is loaded
    if (!props.payments) return;
    // filter items
    let _com = filter_com;
    let _ref = filter_ref.toUpperCase().trim();
    let ls = props.payments;
    if (_com) ls = ls.filter(x => x.company == _com);
    if (_ref) ls = ls.filter(x =>
      -1<String(x.ref_code||'').toUpperCase().indexOf(_ref)
    );
    setItems(Array.from(ls));
  }, [filter_com, filter_ref, props.payments]);

  let minMaxStyle = maximize_list
    ?'box op-payment-history maximized'
    :'box op-payment-history';

  return (
    <div className={minMaxStyle}>
      <h4 className="box-head">
        <div className="action-panel">
          <span>收款</span>
          <div className="button-group">
            <span id="btn-mx-hist">
            { maximize_list
              ?<FontAwesomeIcon icon={faWindowMinimize} onClick={ toggleMaximize } />
              :<FontAwesomeIcon icon={faWindowMaximize} onClick={ toggleMaximize } />
            }
            </span>
            <Protected allow={['ADMIN','OPERATOR']}>
              <button type="button" className="btn small green" onClick={showAddModal}>
                <FontAwesomeIcon icon={faPlus} />
              </button>
            </Protected>
          </div>
        </div>
      </h4>
      <div className="box-body">
        <div className="search-bar">
          <div className="row">
            <label className="field-row">
              <strong>公司</strong>
              <select value={filter_com}
                onChange={e=>setFilterCompany(e.target.value)}>
                <option value="">全部</option>
                { Data.company.map(com =>
                  <option key={com.cd} value={com.cd}>{com.cd} - {com.name}</option>
                )}
              </select>
            </label>
            <label className="field-row">
              <strong>參考編號</strong>
              <input type="text" value={filter_ref}
                onChange={e=>setFilterRef(e.target.value)} />
            </label>
          </div>
        </div>
        { !items?.length
          ?<p className="message yellow">無紀錄</p>
          :<div className="payments">
            <table className="data-table full-width">
              <colgroup>
                <col width="24px"  id="col-payment-btn"/>
                <col width="50px"  id="col-payment-company"/>
                <col width="110px" id="col-payment-date"/>
                <col width="50px"  id="col-payment-type"/>
                <col width="70px"  id="col-payment-amount"/>
                <col width="auto"  id="col-payment-ref"/>
                <col width="auto"  id="col-payment-paymo"/>
                <col width="80px"  id="col-payment-mod-by"/>
              </colgroup>
              <thead>
                <tr>
                  <th className="col-payment-btn"></th>
                  <th className="col-payment-company">公司</th>
                  <th className="col-payment-date">入賬日期</th>
                  <th className="col-payment-type">種類</th>
                  <th className="col-payment-amount">金額</th>
                  <th className="col-payment-ref">收據編號</th>
                  <th className="col-payment-paymo">收費月份</th>
                  <th className="col-payment-mod-by">修訂人</th>
                </tr>
              </thead>
              <tbody>
                { items.map(iv =>
                  <tr key={`${iv.ix_yrmo}-${iv.useq}`}>
                    <td className="col-payment-btn" onClick={e=>showPaymentDetail(iv)}>
                      <FontAwesomeIcon icon={faFileImage} />
                    </td>
                    <td className="col-payment-company">{ Util.getCompanyName(iv.company) }</td>
                    <td className="col-payment-date">{ Util.ShortDate(iv.transfer_dtm) }</td>
                    <td className="col-payment-type">{ Util.getPaymentType(iv.payment_type) }</td>
                    <td className="col-payment-amount">${ iv.amount }</td>
                    <td className="col-payment-ref" title={iv.ref_code}>{ iv.ref_code }</td>
                    <td className="col-payment-paymo" title={ getPaymonthTitle(iv) }>
                      { iv.pay_month?.map(p =>
                        <div key={p.l}>{ getPaymonthRowText(p) }</div>
                      )}
                    </td>
                    <td className="col-payment-mod-by">{ iv.mod_by }</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        }
      </div>
      { modal }
    </div>
  );
}

export default PaymentList;